import { eventBus } from '@/services/event-bus';

interface HashService {
  lastHash: object | null,
  currentHash: Function;
  init: Function;
  setHash: Function;
}

export default {
	lastHash: null,
	init(): void {
		window.addEventListener('hashchange', () => {
			if(JSON.stringify(this.lastHash) === JSON.stringify(this.currentHash()))
				return;

		  this.lastHash = this.currentHash();
			eventBus.$emit('hash-changed', this.currentHash());
		});
	},
	currentHash(): object {
		const obj: {[index: string]: string} = {};
		new URLSearchParams(location.hash.slice(1))
			.forEach((value, key) => obj[key] = value);
		return obj;
	},
	setHash(obj: { [index:string]: string }, clearOther?: boolean): void {
		const newHash = clearOther ? obj : { ...this.currentHash(), ...obj };
		const str: string[] = [];
		Object.keys(newHash)
			.sort((a, b) =>  b.localeCompare(a))
			.forEach(key => {
				str.push(encodeURIComponent(key) + '=' + encodeURIComponent(newHash[key]));
			});

		location.hash = str.join('&');
	}
} as HashService;
